import { Avatar, Box, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemText, Paper, Stack } from "@mui/material"
import { ReactNode, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { store } from "../../../app/store"
import { ProcessDocumentOverview, ProcessStageOverview } from "./validationProcessApi"
import { loadManyBlobs, selectBlobsByResourceId } from "../../documents/attachementsSlice"
import { BlobLink } from "../../documents/BlobLink"
import DownloadIcon from '@mui/icons-material/Download'
import FileCopyIcon from '@mui/icons-material/FileCopy'

interface AttachmentsBoardProps {
    stages: ProcessStageOverview[]
}
export const AttachmentsBoard = (props: AttachmentsBoardProps) => {
    const { stages } = props
    const dispatch = useAppDispatch()

    useEffect(() => {
        let guids: string[] = []
        for (let i = 0; i < stages.length; i++) {
            const stage = stages[i];
            for (let j = 0; j < stage.documents.length; j++) {
                const doc = stage.documents[j];
                const blobs = selectBlobsByResourceId(store.getState(), doc.guid)
                if (blobs === undefined) {
                    guids.push(doc.guid)
                }
            }
        }

        if (guids.length > 0) {
            dispatch(loadManyBlobs(guids))
        }
    }, [stages])

    let cards: ReactNode[] = []
    for (let i = 0; i < stages.length; i++) {
        const stage = stages[i];
        for (let j = 0; j < stage.documents.length; j++) {
            const doc = stage.documents[j];
            cards.push( <Card key={doc.guid} doc={doc} />)
        }
    }

    return <Box sx={{
        display: 'flex',
        gap: 2,
        [`& > div`]: {
            maxWidth: '400px',
        },
        [`& span.MuiListItemText-primary`]: {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        },
    }}>
        {cards}
    </Box>
}

const Card = (props: { doc: ProcessDocumentOverview}) => {
    const { doc } = props
    const blobs = useAppSelector(state => selectBlobsByResourceId(state, doc.guid))

    if (!blobs || blobs.blobs === null || blobs.blobs.length === 0) return null

    return <Paper sx={{
        borderRadius: 2,
    }}>
        <Box sx={{
            p: 1,
            bgcolor: 'var(--gray-100)',
        }}>
            <Box><b>{doc.no}</b></Box>
            <Box><small>{doc.title}</small></Box>
        </Box>
        <List>
            {blobs.blobs.map(({ fileMeta, blobId }) =>
                <ListItem secondaryAction={
                    <Stack direction='row'>
                        <BlobLink blobId={blobId} target="_blank">
                            <IconButton><DownloadIcon /></IconButton>
                        </BlobLink>
                    </Stack>
                }>
                    <ListItemAvatar>
                        <Avatar>
                            <FileCopyIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={fileMeta.fileName} secondary={fileMeta.contentType} />
                </ListItem>)}
        </List>
    </Paper>
}
